<template>
  <tk-container class="setLease" :status="status">
    <tkui-header center slot="header">
      <tk-icon slot="left-menu" @click.native="back">Return</tk-icon>
      租赁设置
      <span slot="right-menu" @click="setConfig">设置</span>
    </tkui-header>
    <div class="body">
      <tk-flex class="item" between middle>
        <p class="itemName">租赁模式</p>
        <div>
          <span class="val">{{state}}</span>
          <tkui-toggle v-model="value" type="switch"></tkui-toggle>
        </div>
      </tk-flex>
      <p class="name">模式设置</p>
      <div class="item">
        <div class="types">
          <span @click="toggleType('isTime')" class="type" :class="{'selected': type === 'isTime'}">按时间</span>
          <span @click="toggleType('isWater')" class="type" :class="{'selected': type === 'isWater'}">按用水量</span>
        </div>
        <!--<p class="itemName border">时&nbsp;&nbsp;&nbsp;&nbsp;间：{{config.lease && config.lease.time && type === 'isTime' ? config.lease.time : 0}}天</p>-->
        <!--<p class="itemName">用水量：{{config.lease && config.lease.water && type === 'isWater' ? config.lease.water : 0}}升</p>-->
      </div>
      <div class="input">
        <tkui-input v-model="time" v-show="type === 'isTime'" placeHolder="请输入租赁时间" label="时间(天):"></tkui-input>
        <tkui-input v-model="water" v-show="type === 'isWater'" placeHolder="请输入租赁水量" label="用水量(升):"></tkui-input>
      </div>
    </div>
  </tk-container>
</template>

<script>
  export default {
    data () {
      return {
        status: false,
        value: false,
        type: 'isTime',
        time: '',
        water: ''
      }
    },
    computed: {
      state () {
        return this.value ? '启动' : '停用'
      },
      lease () {
        return this.$store.state.lease || {}
      },
      machine () {
        return this.$store.state.machine
      },
      config () {
        return this.$store.state.config
      }
    },
    created () {
      if (this.lease) {
        this.value = this.lease.isStart || false
        this.type = this.lease.type || 'isTime'
        this.water = this.lease.water || ''
        this.time = this.lease.time || ''
      }
    },
    methods: {
      back () {
        this.$back()
      },
      toggleType (type) {
        if (this.type === type) return
        this.type = type
      },
      async setConfig () {
        try {
          let lease = {
            isStart: this.value,
            type: this.type,
            time: this.time || '',
            water: this.water || ''
          }
          let objectId = this.config.objectId
          if (objectId) {
//            if (this.lease) {
//              let start = this.lease.isStart === this.value
//              let type = this.lease.type === this.type
//              let water = this.lease.water ? this.lease.water === this.water : !this.water
//              let time = this.lease.time ? this.lease.time === this.time : !this.time
//              if (start && type && water && time) {
//                return false
//              }
//            }
//            修改设置，但是在这之前应该下发命令。如果成功，那么修改数据库。
            this.status = 'waiting'
            await this.$tkParse.put(`/classes/config/${objectId}`, {
              lease: lease
            })
          } else {
            let res = await this.$tkParse.post('/classes/config', {
              lease: lease,
              machine: this.machine.objectId,
              authInfo: this.machine.authInfo || '',
              deviceId: this.machine.deviceId || ''
            })
            console.log(res)
//            方法已删除
//            this.$store.commit('setConfig', res.data)
          }
          this.status = false
          this.$store.commit('setLeaseMode', lease)
          this.$setFlash('isStart', this.value)
          this.$tkGlobal.toast.add('设置成功')
        } catch (e) {
          console.log(e)
          this.status = false
          this.$tkGlobal.toast.add('设置失败')
        }
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .body{
    .name{
      padding: 10px 15px;
      font-size: 14px;
      color: #666666;
    }
    .item{
      background: #ffffff;
      padding: 15px;
      .itemName{
        font-size: 16px;
        color: #333333;
        font-weight: 700;
      }
      .border{
        padding: 15px 0;
        margin-bottom: 15px;
        border-bottom: 1px solid #F6F4F5;
      }
      .val{
        font-size: 14px;
        color: #666666;
      }
      .types{
        .type{
          display: inline-block;
          width: 80px;
          height: 30px;
          box-sizing: border-box;
          border: 1px solid #CCCCCC;
          line-height: 30px;
          text-align: center;
          font-size: 14px;
          color: #999999;
        }
        .selected{
          width: 90px;
          border-color: #2395FF;
          color: #2395FF;
        }
      }
    }
    .input{
      background: #ffffff;
      padding-bottom: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/app/remote/setLease.vue